import { LoyaltyPerEntityGridView } from '~/components/loyalty/per-entity';
import { PageContainer } from '~/components/page-container';

export function LoyaltyPerEntity() {
	return (
		<PageContainer>
			<LoyaltyPerEntityGridView />
		</PageContainer>
	);
}
